<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      eager
      scrollable
      max-width="1200px"
      content-class="rounded-dialog"
    >
      <v-form ref="MPOROutput" @submit.prevent>
        <v-card>
          <!-- <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span>Update Outputs</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeD()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title> -->

          <v-card-title dark class="dialog-header">
            <div class="dialog-header-content">
              <div class="dialog-title-wrapper">
                <div class="dialog-icon">
                  <icon name="global-icon" />
                </div>

                <div class="dialog-text">
                  <div class="dialog-title">Update Outputs</div>

                  <div class="dialog-subtitle">Manage and update MPOR.</div>
                </div>
              </div>

              <v-btn icon class="close-btn" @click="closeD()">
                <icon name="circle-close" />
              </v-btn>
            </div>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-2">
            <v-container>
              <v-row align="stretch">
                <v-col cols="12" md="4">
                  <div class="global-section-header">
                    <div>
                      <div class="global-section-title">Efficiency (E)</div>
                      <div class="global-section-subtitle">
                        Weekly Efficiency Performance
                      </div>
                    </div>

                    <v-chip
                      v-if="eff_is_rated == 0"
                      x-small
                      color="error"
                      outlined
                    >
                      Not Rated
                    </v-chip>
                  </div>

                  <!-- Week 1 -->
                  <div class="week-card mb-6">
                    <div class="week-header">
                      <div>
                        <div class="week-title">Week 1</div>
                        <div class="week-subtitle">Efficiency Score</div>
                      </div>
                    </div>

                    <v-text-field
                      outlined
                      label="Score"
                      v-model="e_w1"
                      @keyup="setWeekValue('w1')"
                      :disabled="eff_is_rated == 0"
                      :rules="[formRules.onlyNumberNoNegative]"
                      type="number"
                      class="score-field"
                    />
                  </div>

                  <!-- Week 2 -->
                  <div class="week-card mb-6">
                    <div class="week-header">
                      <div>
                        <div class="week-title">Week 2</div>
                        <div class="week-subtitle">Efficiency Score</div>
                      </div>
                    </div>

                    <v-text-field
                      outlined
                      label="Score"
                      v-model="e_w2"
                      @keyup="setWeekValue('w2')"
                      :disabled="eff_is_rated == 0"
                      :rules="[formRules.onlyNumberNoNegative]"
                      type="number"
                      class="score-field"
                    />
                  </div>

                  <!-- Week 3 -->
                  <div class="week-card mb-6">
                    <div class="week-header">
                      <div>
                        <div class="week-title">Week 3</div>
                        <div class="week-subtitle">Efficiency Score</div>
                      </div>
                    </div>

                    <v-text-field
                      outlined
                      label="Score"
                      v-model="e_w3"
                      @keyup="setWeekValue('w3')"
                      :disabled="eff_is_rated == 0"
                      :rules="[formRules.onlyNumberNoNegative]"
                      type="number"
                      class="score-field"
                    />
                  </div>

                  <!-- Week 4 -->
                  <div class="week-card mb-6">
                    <div class="week-header">
                      <div>
                        <div class="week-title">Week 4</div>
                        <div class="week-subtitle">Efficiency Score</div>
                      </div>
                    </div>

                    <v-text-field
                      outlined
                      label="Score"
                      v-model="e_w4"
                      @keyup="setWeekValue('w4')"
                      :disabled="eff_is_rated == 0"
                      :rules="[formRules.onlyNumberNoNegative]"
                      type="number"
                      class="score-field"
                    />
                  </div>
                </v-col>
                <v-col cols="12" md="4" v-if="qly_is_rated">
                  <div>
                    <div class="global-section-header">
                      <div>
                        <div class="global-section-title">Quality (Q)</div>

                        <div class="global-section-subtitle">
                          Weekly Quality Performance Rating
                        </div>
                      </div>

                      <v-chip
                        v-if="qly_is_rated == 0"
                        x-small
                        outlined
                        color="error"
                      >
                        Not Rated
                      </v-chip>
                    </div>
                  </div>

                  <v-row>
                    <!-- Week 1 -->
                    <v-col cols="12">
                      <div class="week-card">
                        <div class="rating-container">
                          <div class="rating-label">Select Rating</div>

                          <v-radio-group
                            row
                            hide-details
                            class="modern-rating-group"
                            :disabled="qly_is_rated == 0"
                            v-model="q_rating_w1"
                            @change="setQTVal('w1', 'Q')"
                          >
                            <v-radio
                              v-for="i in 5"
                              :key="i"
                              :label="i.toString()"
                              :value="i"
                              color="#147452"
                            />
                          </v-radio-group>
                        </div>

                        <v-text-field
                          outlined
                          readonly
                          label="Computed Score"
                          v-model="q_w1"
                          :disabled="qly_is_rated == 0"
                          class="score-field"
                          color="#147452"
                        />
                      </div>
                    </v-col>

                    <!-- Week 2 -->
                    <v-col cols="12">
                      <div class="week-card">
                        <div class="rating-container">
                          <div class="rating-label">Select Rating</div>

                          <v-radio-group
                            row
                            hide-details
                            class="modern-rating-group"
                            :disabled="qly_is_rated == 0"
                            v-model="q_rating_w2"
                            @change="setQTVal('w2', 'Q')"
                          >
                            <v-radio
                              v-for="i in 5"
                              :key="i"
                              :label="i.toString()"
                              :value="i"
                              color="#147452"
                            />
                          </v-radio-group>
                        </div>

                        <v-text-field
                          outlined
                          readonly
                          label="Computed Score"
                          v-model="q_w2"
                          :disabled="qly_is_rated == 0"
                          class="score-field"
                          color="#147452"
                        />
                      </div>
                    </v-col>

                    <!-- Week 3 -->
                    <v-col cols="12">
                      <div class="week-card">
                        <div class="rating-container">
                          <div class="rating-label">Select Rating</div>

                          <v-radio-group
                            row
                            hide-details
                            class="modern-rating-group"
                            :disabled="qly_is_rated == 0"
                            v-model="q_rating_w3"
                            @change="setQTVal('w3', 'Q')"
                          >
                            <v-radio
                              v-for="i in 5"
                              :key="i"
                              :label="i.toString()"
                              :value="i"
                              color="#147452"
                            />
                          </v-radio-group>
                        </div>

                        <v-text-field
                          outlined
                          readonly
                          label="Computed Score"
                          v-model="q_w3"
                          :disabled="qly_is_rated == 0"
                          class="score-field"
                          color="#147452"
                        />
                      </div>
                    </v-col>

                    <!-- Week 4 -->
                    <v-col cols="12">
                      <div class="week-card">
                        <div class="rating-container">
                          <div class="rating-label">Select Rating</div>

                          <v-radio-group
                            row
                            hide-details
                            class="modern-rating-group"
                            :disabled="qly_is_rated == 0"
                            v-model="q_rating_w4"
                            @change="setQTVal('w4', 'Q')"
                          >
                            <v-radio
                              v-for="i in 5"
                              :key="i"
                              :label="i.toString()"
                              :value="i"
                              color="#147452"
                            />
                          </v-radio-group>
                        </div>

                        <v-text-field
                          outlined
                          readonly
                          label="Computed Score"
                          v-model="q_w4"
                          :disabled="qly_is_rated == 0"
                          class="score-field"
                          color="#147452"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4">
                  <div>
                    <div class="global-section-header">
                      <div>
                        <div class="global-section-title">Timeliness (T)</div>

                        <div class="global-section-subtitle">
                          Weekly Timeliness Performance Rating
                        </div>
                      </div>

                      <v-chip
                        v-if="timeliness_is_rated == 0"
                        x-small
                        outlined
                        color="error"
                      >
                        Not Rated
                      </v-chip>
                    </div>
                  </div>

                  <v-row>
                    <!-- Week 1 -->
                    <v-col cols="12">
                      <div class="week-card">
                        <div class="rating-container">
                          <div class="rating-label">Select Rating</div>

                          <v-radio-group
                            row
                            hide-details
                            class="modern-rating-group"
                            :disabled="timeliness_is_rated == 0"
                            v-model="t_rating_w1"
                            @change="setQTVal('w1', 'T')"
                          >
                            <v-radio
                              v-for="i in 5"
                              :key="i"
                              :label="i.toString()"
                              :value="i"
                              color="#147452"
                            />
                          </v-radio-group>
                        </div>

                        <v-text-field
                          outlined
                          readonly
                          label="Computed Score"
                          v-model="t_w1"
                          :disabled="timeliness_is_rated == 0"
                          class="score-field"
                          color="#147452"
                        />
                      </div>
                    </v-col>

                    <!-- Week 2 -->
                    <v-col cols="12">
                      <div class="week-card">
                        <div class="rating-container">
                          <div class="rating-label">Select Rating</div>

                          <v-radio-group
                            row
                            hide-details
                            class="modern-rating-group"
                            :disabled="timeliness_is_rated == 0"
                            v-model="t_rating_w2"
                            @change="setQTVal('w2', 'T')"
                          >
                            <v-radio
                              v-for="i in 5"
                              :key="i"
                              :label="i.toString()"
                              :value="i"
                              color="#147452"
                            />
                          </v-radio-group>
                        </div>

                        <v-text-field
                          outlined
                          readonly
                          label="Computed Score"
                          v-model="t_w2"
                          :disabled="timeliness_is_rated == 0"
                          class="score-field"
                          color="#147452"
                        />
                      </div>
                    </v-col>

                    <!-- Week 3 -->
                    <v-col cols="12">
                      <div class="week-card">
                        <div class="rating-container">
                          <div class="rating-label">Select Rating</div>

                          <v-radio-group
                            row
                            hide-details
                            class="modern-rating-group"
                            :disabled="timeliness_is_rated == 0"
                            v-model="t_rating_w3"
                            @change="setQTVal('w3', 'T')"
                          >
                            <v-radio
                              v-for="i in 5"
                              :key="i"
                              :label="i.toString()"
                              :value="i"
                              color="#147452"
                            />
                          </v-radio-group>
                        </div>

                        <v-text-field
                          outlined
                          readonly
                          label="Computed Score"
                          v-model="t_w3"
                          :disabled="timeliness_is_rated == 0"
                          class="score-field"
                          color="#147452"
                        />
                      </div>
                    </v-col>

                    <!-- Week 4 -->
                    <v-col cols="12">
                      <div class="week-card">
                        <div class="rating-container">
                          <div class="rating-label">Select Rating</div>

                          <v-radio-group
                            row
                            hide-details
                            class="modern-rating-group"
                            :disabled="timeliness_is_rated == 0"
                            v-model="t_rating_w4"
                            @change="setQTVal('w4', 'T')"
                          >
                            <v-radio
                              v-for="i in 5"
                              :key="i"
                              :label="i.toString()"
                              :value="i"
                              color="#147452"
                            />
                          </v-radio-group>
                        </div>

                        <v-text-field
                          outlined
                          readonly
                          label="Computed Score"
                          v-model="t_w4"
                          :disabled="timeliness_is_rated == 0"
                          class="score-field"
                          color="#147452"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" class="pt-4">
                  <div class="global-remarks-header">
                    <div>
                      <div class="global-remarks-title">Remarks</div>

                      <div class="global-remarks-subtitle">
                        Add observations, recommendations, or additional
                        comments.
                      </div>
                    </div>
                  </div>

                  <v-textarea
                    v-model="remarks"
                    outlined
                    hide-details
                    rows="4"
                    auto-grow
                    placeholder="Enter your remarks here..."
                    class="global-remarks-textarea mt-4"
                    color="#147452"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>

            <v-btn class="btn-cancel" outlined @click="closeD()">
              Cancel
            </v-btn>

            <v-btn
              color="#519043"
              class="btn-save"
              @click="save()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    ></fade-away-message-component>
  </div>
</template>

<script>
import icon from "@/assets/icon.vue";
export default {
  components: {
    icon,
  },
  props: {
    data: null,
  },

  data() {
    return {
      id: null,
      e_w1: null,
      e_w2: null,
      e_w3: null,
      e_w4: null,
      q_w1: null,
      q_w2: null,
      q_w3: null,
      q_w4: null,
      q_rating_w1: null,
      q_rating_w2: null,
      q_rating_w3: null,
      q_rating_w4: null,
      t_w1: null,
      t_w2: null,
      t_w3: null,
      t_w4: null,
      t_rating_w1: null,
      t_rating_w2: null,
      t_rating_w3: null,
      t_rating_w4: null,
      remarks: null,
      eff_is_rated: null,
      qly_is_rated: null,
      timeliness_is_rated: null,
      dialog: false,
      isSubmitLoading: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("MPOR DATA", data);
        if (data.mpor.id) {
          this.id = data.mpor.id;
          this.e_w1 = data.mpor.e_w1;
          this.e_w2 = data.mpor.e_w2;
          this.e_w3 = data.mpor.e_w3;
          this.e_w4 = data.mpor.e_w4;
          this.q_w1 = data.mpor.q_w1;
          this.q_w2 = data.mpor.q_w2;
          this.q_w3 = data.mpor.q_w3;
          this.q_w4 = data.mpor.q_w4;
          this.t_w1 = data.mpor.t_w1;
          this.t_w2 = data.mpor.t_w2;
          this.t_w3 = data.mpor.t_w3;
          this.t_w4 = data.mpor.t_w4;
          this.q_rating_w1 = data.qly_is_rated
            ? data.mpor.q_rating_w1
              ? data.mpor.q_rating_w1
              : 5
            : null;
          this.q_rating_w2 = data.qly_is_rated
            ? data.mpor.q_rating_w2
              ? data.mpor.q_rating_w2
              : 5
            : null;
          this.q_rating_w3 = data.qly_is_rated
            ? data.mpor.q_rating_w3
              ? data.mpor.q_rating_w3
              : 5
            : null;
          this.q_rating_w4 = data.qly_is_rated
            ? data.mpor.q_rating_w4
              ? data.mpor.q_rating_w4
              : 5
            : null;
          this.t_rating_w1 = data.timeliness_is_rated
            ? data.mpor.t_rating_w1
              ? data.mpor.t_rating_w1
              : 5
            : null;
          this.t_rating_w2 = data.timeliness_is_rated
            ? data.mpor.t_rating_w2
              ? data.mpor.t_rating_w2
              : 5
            : null;
          this.t_rating_w3 = data.timeliness_is_rated
            ? data.mpor.t_rating_w3
              ? data.mpor.t_rating_w3
              : 5
            : null;
          this.t_rating_w4 = data.timeliness_is_rated
            ? data.mpor.t_rating_w4
              ? data.mpor.t_rating_w4
              : 5
            : null;
          this.remarks = data.mpor.remarks;
          this.eff_is_rated = data.eff_is_rated;
          this.qly_is_rated = data.qly_is_rated;
          this.timeliness_is_rated = data.timeliness_is_rated;
        }
      },

      deep: true,
    },
  },

  methods: {
    initialize() {},
    getMFODesc(id) {
      return this.mfoList[id - 1];
    },
    closeD() {
      this.isSubmitLoading = false;
      this.dialog = false;
      this.eventHub.$emit("closeMPOROutputDialog", false);
    },
    setWeekValue(week) {
      console.log(week);
      if (week == "w1") {
        this.q_w1 = this.q_rating_w1 ? this.e_w1 * this.q_rating_w1 : null;
        this.t_w1 = this.t_rating_w1 ? this.e_w1 * this.t_rating_w1 : null;
      } else if (week == "w2") {
        this.q_w2 = this.q_rating_w2 ? this.e_w2 * this.q_rating_w2 : null;
        this.t_w2 = this.t_rating_w2 ? this.e_w2 * this.t_rating_w2 : null;
      } else if (week == "w3") {
        this.q_w3 = this.q_rating_w3 ? this.e_w3 * this.q_rating_w3 : null;
        this.t_w3 = this.t_rating_w3 ? this.e_w3 * this.t_rating_w3 : null;
      } else if (week == "w4") {
        this.q_w4 = this.q_rating_w4 ? this.e_w4 * this.q_rating_w4 : null;
        this.t_w4 = this.t_rating_w4 ? this.e_w4 * this.t_rating_w4 : null;
      }
    },

    setQTVal(week, type) {
      if (week == "w1") {
        if (type == "Q") {
          this.q_w1 = this.q_rating_w1 ? this.e_w1 * this.q_rating_w1 : null;
        } else {
          this.t_w1 = this.t_rating_w1 ? this.e_w1 * this.t_rating_w1 : null;
        }
      } else if (week == "w2") {
        if (type == "Q") {
          this.q_w2 = this.q_rating_w2 ? this.e_w2 * this.q_rating_w2 : null;
        } else {
          this.t_w2 = this.t_rating_w2 ? this.e_w2 * this.t_rating_w2 : null;
        }
      } else if (week == "w3") {
        if (type == "Q") {
          this.q_w3 = this.q_rating_w3 ? this.e_w3 * this.q_rating_w3 : null;
        } else {
          this.t_w3 = this.t_rating_w3 ? this.e_w3 * this.t_rating_w3 : null;
        }
      } else if (week == "w4") {
        if (type == "Q") {
          this.q_w4 = this.q_rating_w4 ? this.e_w4 * this.q_rating_w4 : null;
        } else {
          this.t_w4 = this.t_rating_w4 ? this.e_w4 * this.t_rating_w4 : null;
        }
      }
    },

    save() {
      if (this.$refs.MPOROutput.validate()) {
        this.isSubmitLoading = true;
        let data = {
          e_w1: this.e_w1,
          e_w2: this.e_w2,
          e_w3: this.e_w3,
          e_w4: this.e_w4,
          q_w1: this.q_w1,
          q_w2: this.q_w2,
          q_w3: this.q_w3,
          q_w4: this.q_w4,
          t_w1: this.t_w1,
          t_w2: this.t_w2,
          t_w3: this.t_w3,
          t_w4: this.t_w4,
          q_rating_w1: this.q_rating_w1,
          q_rating_w2: this.q_rating_w2,
          q_rating_w3: this.q_rating_w3,
          q_rating_w4: this.q_rating_w4,
          t_rating_w1: this.t_rating_w1,
          t_rating_w2: this.t_rating_w2,
          t_rating_w3: this.t_rating_w3,
          t_rating_w4: this.t_rating_w4,
          remarks: this.remarks,
        };
        // console.log(data);
        this.axiosCall(
          "/ipcr-mpor/updateMyMPOROutput/" + this.id,
          "PATCH",
          data,
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },
  },
};
</script>
